import { useState } from "react";
import { IoChevronForwardSharp } from "react-icons/io5";
import classes from "./Accordion.module.css";
import { cn } from "@/helper/HelperFunction";

function AccordionComponent({ data }) {
  const [expandedItems, setExpandedItems] = useState(new Set());

  const toggleItem = (index) => {
    const newExpandedItems = new Set(expandedItems);
    if (newExpandedItems.has(index)) {
      newExpandedItems.delete(index);
    } else {
      newExpandedItems.add(index);
    }
    setExpandedItems(newExpandedItems);
  };

  return (
    <div className={classes.accordionRoot}>
      {data &&
        data.map((item, index) => {
          const isExpanded = expandedItems.has(index);
          return (
            <div key={index} className={classes.accordionItem}>
              <button
                className={classes.accordionButton}
                onClick={() => toggleItem(index)}
              >
                <span className={classes.accordionText}>{item?.question}</span>
                <span
                  className={`${classes.accordionChevron} ${
                    isExpanded ? classes.chevronRotated : ""
                  }`}
                >
                  <IoChevronForwardSharp />
                </span>
              </button>
              {isExpanded && (
                <div className={classes.accordionContent}>
                  <div className={classes.accordionSeparator} />
                  {typeof item?.answer === "string" ? (
                    <div className={classes.accordionAnswer}>
                      {item?.answer}
                    </div>
                  ) : (
                    item?.answer?.map((ele, index) => (
                      <div key={index} className={classes.accordionAnswerItem}>
                        <div>{ele?.question}</div>
                        <div
                          className={cn(ele?.type === "link" && classes.link)}
                          onClick={() => {
                            if (ele?.type === "link") {
                              window.open(ele?.answer, "_blank");
                            }
                          }}
                        >
                          {ele?.answer}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
}

export default AccordionComponent;
